import * as React from "react"

function SvgComponent(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={484.014}
      height={346.733}
      viewBox="0 0 484.014 346.733"
      {...props}
    >
      <g data-name="Layer 2">
        <g data-name="\u2018\u043B\u043E\u0439_1">
          <path
            data-name="Path 11315"
            d="M42.921 345.536s-81.748-69.8-19.6-135.958C89.486 139.139 30.866 48.72 120.68 12.237c97.1-39.446 122.084 30.027 162.735 19.361 81.078-21.277 183.922-10.8 166.809 92.549-21.48 129.733 66.648 113.186 14.307 221.824z"
            fill="rgba(247,182,134,0.15)"
          />
          <path
            data-name="Path 11316"
            d="M283.411 135.313s13.567-57.509 59.34-63.832c0 0 8.906-1.093 11.874 8.714s-14.742 9.876-25.688 13.82-36.464 20.668-45.526 41.298z"
            fill="#b8d98a"
          />
          <path
            data-name="Path 11317"
            d="M282.362 124.55s-4.76-47.635 28.645-64.541c0 0 6.535-3.186 11.391 3.546s-8.692 11.453-16.038 17.358-22.483 25.443-23.998 43.637z"
            fill="#b8d98a"
          />
          <g data-name="Group 630" opacity={0.8} fill="#a0d468">
            <path
              data-name="Path 11318"
              d="M179.442 169.008s19.632-10.995 10.465-25.914c0 0-7.328-9.163-15.181-11.518 0 0 4.188 22.249 0 22.772s-2.88-25.129-2.88-25.129-20.679-9.946-28.794-9.161c0 0 12.826 21.736 8.638 21.2s-18.581-22.52-18.581-22.52-21.21-3.92-24.605 8.654 2.093 18.846 5.233 19.632 23.3.523 22.774 3.14-14.136 6.807-21.736 4.45c0 0 8.378 20.681 19.371 19.632s14.4-7.849 21.2-8.376 11.779 1.31 8.376 3.142-14.921.6-20.417 5.275-9.948 7.551.262 9.646 28.532.785 32.2-7.068z"
            />
            <path
              data-name="Path 11319"
              d="M118.188 131.315s54.971 17.8 61.254 37.693a41.832 41.832 0 005.233 19.119v3.927s-5.758-13.359-8.9-15.193c.002 0 12.305-17.276-57.587-45.546z"
            />
            <path
              data-name="Path 11320"
              d="M184.677 188.117s8.477 12.88 3.645 28.544l-2.182-.586s2.117-17.26-2.318-25.942.855-2.016.855-2.016z"
            />
          </g>
          <g data-name="Group 631" opacity={0.5} fill="#a0d468">
            <path
              data-name="Path 11321"
              d="M190.348 257.771s12.86-38.53-17.5-47.325c0 0-20.917-3.331-34.266 3.063 0 0 32.622 24.626 27.665 30.412s-34.372-30.06-34.372-30.06-39.7 11.838-49.579 22.742c0 0 43.521 13.432 37.293 17.821s-52.168-7.483-52.168-7.483-33.084 20.514-22.366 41.427 25.692 22.623 30.84 19.858 31.746-27.6 34.228-23.472-10.608 26.26-23.607 32.336c0 0 36.306 17.441 49.71 2.687s9.686-27.974 18.139-36.944 17.32-12.561 15-5.979-19.2 18.918-20.86 31.845-4.108 22.17 12.075 12.564 39.056-33.61 34.415-48.551z"
            />
            <path
              data-name="Path 11322"
              d="M62.762 281.845s95.023-43.008 127.586-24.074c0 0 11.069 13.571 4.645 14.939 0-.008-4.559-38.017-132.231 9.135z"
            />
          </g>
          <path
            data-name="Path 11323"
            d="M330.878 261.889s3.79-23.044 21.589-19.379c0 0 11.53 3.914 16.606 10.745 0 0-23.193 3.778-22.223 8.05s25.539-6.074 25.539-6.074 17.016 16.664 19.12 24.861c0 0-25.735-4.83-23.749-.936s28.536 10.179 28.536 10.179 11.327 19.3.27 27.063-19.131 4.629-21.009 1.831-8.745-22.541-11.116-21.114-1.644 16.2 3.339 22.774c0 0-23.144-.864-26.006-11.963s2.576-16.823.68-23.65-5.434-11.033-6.025-7.064 4.687 14.772 2.071 21.788-3.854 12.375-9.507 3.154-10.85-27.572-4.484-33.916z"
            fill="#b8d98a"
          />
          <path
            data-name="Path 11324"
            d="M389.313 308.336s-36.8-47.349-58.435-46.448a43.328 43.328 0 01-20.5 1.644l-3.824 1.389s15.062.9 17.96 3.319c-.001 0 12.511-18.113 64.799 40.096z"
            fill="#bbd0ff"
          />
          <path
            data-name="Path 11325"
            d="M310.386 263.534s-15.559-3.721-29.142 6.533l1.342 1.922s16.1-8.167 26.133-6.907 1.667-1.548 1.667-1.548z"
            fill="#bbd0ff"
          />
          <path
            data-name="Path 11326"
            d="M323.965 166.451s-24-13.44-12.8-31.678c0 0 8.96-11.2 18.558-14.088 0 0-5.12 27.2 0 27.84s3.52-30.718 3.52-30.718 25.278-12.16 35.2-11.2c0 0-15.68 26.566-10.56 25.918s22.72-27.51 22.72-27.51 25.918-4.8 30.078 10.56-2.56 23.038-6.4 24-28.478.64-27.837 3.84 17.278 8.318 26.566 5.434c0 0-10.24 25.278-23.678 24s-17.608-9.594-25.926-10.23-14.4 1.6-10.238 3.84 18.238.735 24.956 6.44 12.16 9.232-.32 11.792-34.878.96-39.358-8.638z"
            fill="#b8d98a"
          />
          <path
            data-name="Path 11327"
            d="M398.841 120.374s-67.195 21.76-74.867 46.078c0 0 .32 10.88-6.4 23.358v4.806s7.044-16.318 10.868-18.558c.008-.007-15.036-21.126 70.399-55.684z"
            fill="#d2e0ff"
          />
          <path
            data-name="Path 11328"
            d="M317.568 189.809s-10.363 15.736-4.456 34.892l2.667-.716s-2.588-21.1 2.834-31.71-1.045-2.466-1.045-2.466z"
            fill="#d2e0ff"
          />
          <path
            data-name="Rectangle 1748"
            fill="#165a9f"
            d="M162.993 99.904H342.37v245.302H162.993z"
          />
          <path
            data-name="Rectangle 1749"
            fill="#f3faff"
            d="M170.637 106.524h164.092v231.923H170.637z"
          />
          <path
            data-name="Path 11329"
            d="M218.663 99.904v8.356a8.352 8.352 0 008.354 8.356h44.842a8.352 8.352 0 008.348-8.356v-8.356z"
            fill="#2b478b"
          />
          <path
            data-name="Rectangle 1750"
            fill="#aec3ff"
            d="M189.684 305.62h20.303v2.055h-20.303z"
          />
          <path
            data-name="Rectangle 1751"
            fill="#aec3ff"
            d="M214.688 305.62h20.303v2.055h-20.303z"
          />
          <path
            data-name="Rectangle 1752"
            fill="#aec3ff"
            d="M189.684 310.178h28.156v2.055h-28.156z"
          />
          <path
            data-name="Path 11330"
            d="M213.261 134.545h7.432a6.477 6.477 0 014.738 1.648 5.142 5.142 0 011.393 3.764 5.029 5.029 0 01-3.484 5.031l3.973 5.8h-4.18l-3.53-5.2h-2.765v5.2h-3.576zm7.2 7.9c1.741 0 2.739-.928 2.739-2.345 0-1.534-1.069-2.322-2.818-2.322h-3.554v4.667z"
            fill="#cf1e22"
          />
          <path
            data-name="Path 11331"
            d="M229.798 143.835v-9.29h3.576v9.2c0 2.649 1.322 4.025 3.506 4.025s3.508-1.324 3.508-3.9v-9.325h3.576v9.173c0 4.923-2.763 7.338-7.131 7.338s-7.035-2.437-7.035-7.221z"
            fill="#cf1e22"
          />
          <path
            data-name="Path 11332"
            d="M247.611 134.545h3.576v13.005h8.1v3.25h-11.673z"
            fill="#cf1e22"
          />
          <path
            data-name="Path 11333"
            d="M261.987 134.545h12.261v3.18h-8.708v3.3h7.664v3.182h-7.664v3.418h8.825v3.18h-12.378z"
            fill="#cf1e22"
          />
          <path
            data-name="Path 11334"
            d="M276.433 148.431l2.1-2.52a7.453 7.453 0 004.852 1.972c1.463 0 2.347-.58 2.347-1.578 0-.906-.557-1.371-3.275-2.067-3.274-.837-5.388-1.743-5.388-5.017 0-2.948 2.369-4.9 5.69-4.9a9.415 9.415 0 016.038 2.065l-1.85 2.681a7.586 7.586 0 00-4.226-1.61c-1.37 0-2.091.626-2.091 1.463 0 1.069.7 1.409 3.508 2.135 3.3.859 5.154 2.045 5.154 4.925 0 3.22-2.461 5.031-5.967 5.031a10.338 10.338 0 01-6.892-2.58z"
            fill="#cf1e22"
          />
          <path
            data-name="Rectangle 1753"
            fill="#8c9df4"
            d="M207.201 154.634h88.158v1.137h-88.158z"
          />
          <path
            data-name="Path 11335"
            d="M318.314 192.707h-29.677V163.03h29.677zm-28.281-1.4h26.882v-26.88h-26.882z"
            fill="#afcdfb"
          />
          <path
            data-name="Path 11336"
            d="M304.212 186.742a2.1 2.1 0 01-1.61-.761l-9.171-11.079a2.1 2.1 0 013.232-2.671l7.263 8.785 13.138-22.052a2.1 2.1 0 013.6 2.145l-14.66 24.609a2.1 2.1 0 01-1.64 1.018 1.77 1.77 0 01-.152.006z"
            fill="#f99746"
          />
          <path
            data-name="Rectangle 1754"
            fill="#aec3ff"
            d="M199.805 167.41h65.929v2.896h-65.929z"
          />
          <path
            data-name="Rectangle 1755"
            fill="#aec3ff"
            d="M199.805 180.342h60.761v2.896h-60.761z"
          />
          <path
            data-name="Rectangle 1756"
            fill="#aec3ff"
            d="M247.762 173.876h17.972v2.896h-17.972z"
          />
          <path
            data-name="Rectangle 1757"
            fill="#aec3ff"
            d="M199.805 173.876h42.978v2.896h-42.978z"
          />
          <path
            data-name="Path 11337"
            d="M185.045 169.997l-2.95.819-.6-2.341 4.4-1.409h2.006v16.5h-2.86z"
            fill="#aec3ff"
          />
          <path
            data-name="Path 11338"
            d="M189.784 182.54a1.042 1.042 0 111.042 1.042 1.042 1.042 0 01-1.042-1.042z"
            fill="#aec3ff"
          />
          <path
            data-name="Path 11339"
            d="M318.547 237.04h-29.68v-29.677h29.68zm-28.28-1.4h26.88v-26.882h-26.884z"
            fill="#afcdfb"
          />
          <path
            data-name="Path 11340"
            d="M304.442 231.074a2.093 2.093 0 01-1.61-.761l-9.157-11.069a2.1 2.1 0 113.232-2.672l7.264 8.787 13.138-22.054a2.1 2.1 0 113.6 2.148l-14.661 24.607a2.094 2.094 0 01-1.64 1.016c-.06-.004-.108-.002-.166-.002z"
            fill="#f99746"
          />
          <path
            data-name="Path 11341"
            d="M181.36 225.655l5.607-4.766c2.232-1.884 3.047-2.928 3.047-4.393a2.437 2.437 0 00-2.628-2.534c-1.489 0-2.51.805-3.765 2.441l-2.023-1.582c1.558-2.184 3.093-3.421 6-3.421 3.186 0 5.369 1.952 5.369 4.9 0 2.556-1.371 3.929-4.226 6.3l-3.357 2.8h7.74v2.51H181.36z"
            fill="#aec3ff"
          />
          <path
            data-name="Path 11342"
            d="M195.057 226.875a1.036 1.036 0 111.034 1.035 1.036 1.036 0 01-1.034-1.035z"
            fill="#aec3ff"
          />
          <path
            data-name="Rectangle 1758"
            fill="#aec3ff"
            d="M200.35 211.742h69.28v2.896h-69.28z"
          />
          <path
            data-name="Rectangle 1759"
            fill="#aec3ff"
            d="M200.35 224.677h63.848v2.896H200.35z"
          />
          <path
            data-name="Rectangle 1760"
            fill="#aec3ff"
            d="M250.745 218.211h18.886v2.896h-18.886z"
          />
          <path
            data-name="Rectangle 1761"
            fill="#aec3ff"
            d="M200.35 218.211h45.162v2.896H200.35z"
          />
          <path
            data-name="Path 11343"
            d="M318.547 281.701h-29.68v-29.677h29.68zm-28.28-1.4h26.88v-26.882h-26.884z"
            fill="#afcdfb"
          />
          <path
            data-name="Path 11344"
            d="M304.442 275.739a2.1 2.1 0 01-1.61-.761l-9.157-11.069a2.1 2.1 0 113.232-2.673l7.264 8.787 13.138-22.054a2.1 2.1 0 113.6 2.148l-14.668 24.6a2.093 2.093 0 01-1.64 1.006.7.7 0 01-.159.016z"
            fill="#f99746"
          />
          <path
            data-name="Rectangle 1762"
            fill="#aec3ff"
            d="M200.35 256.405h69.28v2.896h-69.28z"
          />
          <path
            data-name="Rectangle 1763"
            fill="#aec3ff"
            d="M200.35 269.336h63.848v2.896H200.35z"
          />
          <path
            data-name="Rectangle 1764"
            fill="#aec3ff"
            d="M250.745 262.869h18.886v2.896h-18.886z"
          />
          <path
            data-name="Rectangle 1765"
            fill="#aec3ff"
            d="M200.35 262.869h45.162v2.896H200.35z"
          />
          <path
            data-name="Path 11345"
            d="M181.153 269.618l1.956-1.811a5.2 5.2 0 004.186 2.093 2.5 2.5 0 002.753-2.457c0-1.57-1.433-2.455-3.663-2.455h-1.3l-.455-1.753 4.3-4.57h-6.887v-2.435h10.532v2.093l-4.428 4.55c2.526.362 4.687 1.66 4.687 4.526 0 2.934-2.276 5.032-5.575 5.032a7.606 7.606 0 01-6.106-2.813z"
            fill="#aec3ff"
          />
          <path
            data-name="Path 11346"
            d="M193.624 271.402a1.006 1.006 0 111.006 1.006 1.006 1.006 0 01-1.006-1.006z"
            fill="#aec3ff"
          />
          <path
            data-name="Path 11347"
            d="M264.76 312.181a12.623 12.623 0 01-12.331-10.051.862.862 0 111.688-.346 10.868 10.868 0 0021.263.1.863.863 0 011.687.362 12.647 12.647 0 01-12.307 9.935z"
            fill="#aec3ff"
          />
          <path
            data-name="Path 11348"
            d="M253.251 298.217a.933.933 0 01-.165-.014.864.864 0 01-.682-1.006 12.591 12.591 0 0124.567-.668.862.862 0 01-1.672.419 10.868 10.868 0 00-21.2.577.863.863 0 01-.848.692z"
            fill="#aec3ff"
          />
          <path
            data-name="Path 11349"
            d="M264.761 317.491a17.894 17.894 0 1117.894-17.894 17.894 17.894 0 01-17.894 17.894zm0-33.336a15.442 15.442 0 1015.442 15.442 15.442 15.442 0 00-15.442-15.445z"
            fill="#aec3ff"
          />
          <path
            data-name="Rectangle 1766"
            fill="#aec3ff"
            d="M261.216 297.352h7.086v1.135h-7.086z"
          />
          <path
            data-name="Rectangle 1767"
            fill="#aec3ff"
            d="M261.216 301.995h7.086v1.135h-7.086z"
          />
          <path
            data-name="Rectangle 1768"
            fill="#aec3ff"
            d="M259.546 299.594h10.431v1.135h-10.431z"
          />
          <path
            data-name="Path 11350"
            d="M148.676 222.648s.555-1.252.918-1.846 1.9-2.333 2.166-1.94 1.312 3.045.755 3.786.036 2.034-2.739 2.817z"
            fill="#ffb27d"
          />
          <path
            data-name="Path 11351"
            d="M117.846 214.741s14.2 11.854 19.739 10.755a109.128 109.128 0 0010.974-3.136l1.33 3.4s-5.961 8.084-12.174 8.137a35.4 35.4 0 01-16.887-4.2z"
            fill="#6980e2"
          />
          <path
            data-name="Path 11352"
            d="M92.94 339.769s.413 6.641 1.7 6.746c.171.012 6.527.012 6.527.012l8.111-.046a2.63 2.63 0 00-2.415-2.369c-2.363-.414-6.34-2.079-7.776-5.212-1.522-3.297-6.147.869-6.147.869z"
            fill="#1c4b8e"
          />
          <path
            data-name="Path 11353"
            d="M92.474 340.232a16.9 16.9 0 004.391.825 16.1 16.1 0 004.1-.586 111.919 111.919 0 013.019-14.382c1.338-5.184 3.252-11.852 5.973-20.125 7.525-22.895 9.811-36.288 10.021-37.556.012-.066.016-.1.016-.1h-.024l-23.132-10.157s2.858 31.555-.789 43.672a51.157 51.157 0 00-1.324 5.8c-2.304 13.129-2.251 32.609-2.251 32.609z"
            fill="#ffa561"
          />
          <path
            data-name="Path 11354"
            d="M103.983 326.09c1.338-5.184 3.252-11.852 5.973-20.126 7.525-22.895 9.811-36.288 10.021-37.556v-.111L96.845 258.14s2.858 31.555-.789 43.673c-.52 1.682 7.927 24.277 7.927 24.277z"
            fill="#f4904d"
          />
          <path
            data-name="Path 11355"
            d="M111.009 339.769s.4 6.641 1.7 6.746c.171.012 6.525.012 6.525.012l8.113-.046a2.633 2.633 0 00-2.415-2.369c-2.361-.414-6.34-2.079-7.776-5.212-1.527-3.297-6.147.869-6.147.869z"
            fill="#1c4b8e"
          />
          <path
            data-name="Path 11356"
            d="M124.123 258.874a329.144 329.144 0 01-3.236 45.552c-3.538 25.1-2.347 35.761-2.347 35.761a24.115 24.115 0 01-3.411.869 15.518 15.518 0 01-5.062-.588s-5.064-25.115-3.623-37.679-6.933-43.119-6.933-43.119z"
            fill="#ffa561"
          />
          <path
            data-name="Path 11357"
            d="M107.72 211.023l4.516 2.963 4.112-1.163c.753-1.073.952-3.14.962-4.931a30.413 30.413 0 00-.161-3.285l-6.092-2.689-2.277-1.005c0 .036.177 1.866.2 2.133a15.552 15.552 0 01-1.26 7.977z"
            fill="#ffb27d"
          />
          <path
            data-name="Path 11358"
            d="M124.228 264.558c-5.621 5.434-26.892 4.514-28.2-1.465s1.429-50.9 11.031-53.717c1.992-.586 12.643 2.858 12.643 2.858a67.615 67.615 0 012.767 9.938c.2 1.085.833 12.563 1.3 23.3.217 5.031.4 9.886.493 13.444a38.7 38.7 0 01-.034 5.642z"
            fill="#8c9df4"
          />
          <path
            data-name="Path 11359"
            d="M109.441 203.132c1.236 2.091 5.573 3.918 7.869 4.758a30.4 30.4 0 00-.161-3.284l-6.092-2.689c-1.346-.016-2.167.286-1.616 1.215z"
            fill="#fca56b"
          />
          <path
            data-name="Path 11360"
            d="M119.448 204.237s-9.815 3.057-11.629-3.081-4.3-9.884 1.89-12.1 8.1-.234 9.209 1.67 3.044 12.555.53 13.511z"
            fill="#ffb27d"
          />
          <path
            data-name="Path 11361"
            d="M118.54 190.137s-.626 7.147-2.1 6.843-3.105-.974-2.89 1.182-1.437 5.848-3.568 5.836c-4.571-.018-9.538-11.749-8.286-13.973 3.599-6.422 22.054-7.716 16.844.112z"
            fill="#163560"
          />
          <path
            data-name="Path 11362"
            d="M117.089 209.53c-.127-.052-7.308-3.272-8.147-3s-1.888 2.85-1.888 2.85l12.645 2.86a6.287 6.287 0 00-2.61-2.71z"
            fill="#6980e2"
          />
          <path
            data-name="Path 11363"
            d="M161.792 244.326l-40.251 37.9c-.789.743-1.783.98-2.214.527l-1.361-1.443c-.427-.455-.131-1.433.658-2.176l40.251-37.9c.789-.743 1.783-.98 2.214-.525l1.358 1.443c.432.443.134 1.423-.655 2.174z"
            fill="#1f4d84"
          />
          <path
            data-name="Path 11364"
            d="M139.205 265.584l-17.664 16.63c-.789.743-1.783.98-2.214.527l-1.361-1.443c-.427-.455-.131-1.433.658-2.175l17.664-16.63z"
            fill="#739af0"
          />
          <path
            data-name="Path 11365"
            d="M152.54 230.008a31.551 31.551 0 1052.292-31.706q-.242-.241-.5-.477a31.551 31.551 0 00-51.8 32.183zm9.016-29.118a29.021 29.021 0 11-7.9 20.8 29.059 29.059 0 017.9-20.8z"
            fill="#1f4d84"
          />
          <g data-name="Group 632">
            <path
              data-name="Path 11366"
              d="M203.884 240.708a28.945 28.945 0 117.924-20.794 29.061 29.061 0 01-7.924 20.794z"
              fill="#b3cff9"
              opacity={0.5}
            />
          </g>
          <path
            data-name="Path 11367"
            d="M124.257 258.915c-22.178-15.8-20.327-36.892-20.327-36.892 8.107 4.571 16.151 14.68 19.842 23.448.199 5.023.399 9.886.485 13.444z"
            fill="#6980e2"
          />
          <path
            data-name="Path 11368"
            d="M146.149 251.718a6.038 6.038 0 002.832-1.749s.668.044-.109 1.467c-.064.119-.2.425-.318.642a.137.137 0 00.117.2 14.775 14.775 0 013.548.075c.24.05.31.624.3.87a2.216 2.216 0 01-.467 1.515c-.28.368-1.061.767-2.8 1.467a8.452 8.452 0 01-4.337-.546l-1.417-.668.441-2.638.356.074c.561.128 1.264-.564 1.854-.709z"
            fill="#ffb27d"
          />
          <path
            data-name="Path 11369"
            d="M110.806 212.235s-19.924 3.794 5.865 32.651c4.124 4.617 26.411 10.626 26.411 10.626s2.26-1.924 1.121-3.482c0 0-15.346-11.141-18.717-12.912-1.52-.8-5.895-17.785-8.37-21.876a11.159 11.159 0 00-6.31-5.007z"
            fill="#8c9df4"
          />
          <path
            data-name="Path 11370"
            d="M149.215 222.992a10.138 10.138 0 00.779-1.9 10.535 10.535 0 011.286-2.912c.135-.135.582.04.634.622a3.346 3.346 0 01-.32 1.26 14.094 14.094 0 00-.421 2.5c-.31 1.007-1.958.43-1.958.43z"
            fill="#ffb27d"
          />
          <path
            data-name="Path 11371"
            d="M215.034 337.116a7.835 7.835 0 00.063 1.006 8.215 8.215 0 008.159 7.219h115.627a8.223 8.223 0 100-16.445H223.255a8.221 8.221 0 00-8.221 8.22z"
            fill="#2b478b"
          />
          <path
            data-name="Path 11372"
            d="M223.855 327.406h39.647a1.266 1.266 0 001.262-1.262 1.266 1.266 0 00-1.262-1.262h-39.647a1.266 1.266 0 00-1.262 1.262 1.266 1.266 0 001.262 1.262z"
            fill="#2b478b"
          />
          <path
            data-name="Rectangle 1769"
            fill="#233862"
            d="M230.339 328.893h-4.297v-1.489h4.297z"
          />
          <path
            data-name="Path 11373"
            d="M216.032 341.049a8.23 8.23 0 007.223 4.289h24.491v-4.289z"
            fill="#233862"
          />
          <path
            data-name="Path 11374"
            d="M362.411 334.709v4.812a5.812 5.812 0 01-5.812 5.814H236.153a5.812 5.812 0 01-5.812-5.814v-4.816a5.812 5.812 0 015.812-5.814h120.446a5.812 5.812 0 015.812 5.818z"
            fill="#f99746"
          />
          <path
            data-name="Path 11375"
            d="M362.208 341.049a5.808 5.808 0 01-5.609 4.289H236.154a5.812 5.812 0 01-5.609-4.289z"
            fill="#ef873a"
          />
          <path
            data-name="Path 11376"
            d="M350.449 337.144a9.155 9.155 0 002.393 6.35l.1.1a5.845 5.845 0 004.126 1.811c2.439 0 8.483-3.679 12.228-6.122 1.865-1.207 3.162-2.129 3.162-2.129s-1.3-.91-3.162-2.129c-3.745-2.445-9.789-6.122-12.228-6.122a5.45 5.45 0 00-2.012.391 6.635 6.635 0 00-2.789 2.2 9.084 9.084 0 00-1.675 4.025v.054a10.152 10.152 0 00-.143 1.571z"
            fill="#8c9df4"
          />
          <path
            data-name="Path 11377"
            d="M350.449 337.145a9.155 9.155 0 002.393 6.35l18.537-6.378-20.808-1.554a10.127 10.127 0 00-.122 1.582z"
            fill="#6980e2"
          />
          <path
            data-name="Path 11378"
            d="M352.252 331.485l18.494 5.049-15.7-7.245a6.643 6.643 0 00-2.794 2.196z"
            fill="#9fb1ff"
          />
          <path
            data-name="Path 11379"
            d="M368.085 337.145a2.291 2.291 0 001.208 2.129c1.865-1.208 3.162-2.129 3.162-2.129s-1.3-.91-3.162-2.13a2.279 2.279 0 00-1.208 2.13z"
            fill="#182d4c"
          />
          <path
            data-name="Path 11380"
            d="M400.883 186.826a6.969 6.969 0 00-5.516-.59c-9.373-1.1-12.106 9.827-11.979 13.589s.556 7.8-3.623 12.679c-12.089 14.112 13.228 14.734 13.228 14.734.216-11.27 13.73-7.161 13.138-6.017 17.321 4.164 1.718-30.78-5.248-34.395z"
            fill="#163560"
          />
          <path
            data-name="Path 11381"
            d="M364.733 231.576s-1.648-2.51-2.976-2.558-3.788-.739-3.593-.245 1.723.541 1.87.835-2.262.739-2.95.787-2.313 0-2.264.346 2.926 1.771 4.957 1.574a13.757 13.757 0 014.538.59z"
            fill="#ffb27d"
          />
          <path
            data-name="Path 11382"
            d="M388.568 232.387a24.6 24.6 0 01-2.522 3.824c-1.958 2.451-4.977 5.285-8.769 5.837a9.414 9.414 0 01-5.211-.845c-4.6-2.043-8.066-6.744-8.066-6.744a3.787 3.787 0 01.517-3.715s9.3 2.091 10.183 1.648 6.33-12.52 7.31-14.531a11.027 11.027 0 015.392-5.5z"
            fill="#ffa561"
          />
          <path
            data-name="Path 11383"
            d="M386.047 236.201c-1.958 2.451-4.977 5.285-8.769 5.837a9.414 9.414 0 01-5.211-.845c.181.024 4.78.592 6.612-2.687 1.871-3.347 3.892-8.654 6.669-6.889 1.2.772 1.146 2.672.699 4.584z"
            fill="#f4904d"
          />
          <path
            data-name="Path 11384"
            d="M423.257 332.753s2.835 2.588 2.282 4.428-3.114 3.067-3.46 5.315-1.729 3.476-2.975 3.476h-5.939s-.916-1.583 1.3-2.061 3.049-3.118 2.91-5.571a43.687 43.687 0 01.2-5.724l4.705-1.091z"
            fill="#fb8145"
          />
          <path
            data-name="Path 11385"
            d="M399.238 333.852s1.02 10.968-.225 11.582l-15.939-.034s0-1.84 2.56-2.248 7.058-1.908 7.819-5.247 5.785-4.053 5.785-4.053z"
            fill="#fb8145"
          />
          <path
            data-name="Path 11386"
            d="M411.506 224.988a63.513 63.513 0 010 7.368c-.159 2.665-2.854 6.239-3.236 7.114-.958 2.214-2.041 2.574-2.041 2.574l-8.368 2.053-2.944.718-9.28-2.771s-4.226-11.8-2.53-18.439a50.954 50.954 0 014.291-11.252s6.291-2.484 17.433-.63z"
            fill="#ffa561"
          />
          <path
            data-name="Path 11387"
            d="M409.056 233.444a26.127 26.127 0 01-.787 6.038c-.958 2.214-2.041 2.574-2.041 2.574l-8.368 2.053-3.636-1.069s12.136-1.84 10.791-12.277z"
            fill="#f2ccaa"
          />
          <path
            data-name="Path 11388"
            d="M386.228 243.837s-4.6 14.305-4.893 19.176 8.787 69.186 9.151 71.43c.352 2.115 2.969 3.467 2.969 3.467a3.973 3.973 0 002.932.226 7.248 7.248 0 003.15-1.484s3.576-45.87 1.362-62.256a259.522 259.522 0 01-2.24-30.555z"
            fill="#18206b"
          />
          <path
            data-name="Path 11389"
            d="M405.698 243.41s7.012 9.407 7.664 15.764 1.027 28.693 2.415 34.891 6.507 18.127 6.507 37.46a3.851 3.851 0 01-2.174 1.7 17.833 17.833 0 01-1.91.529 3.019 3.019 0 01-3.363-1.6c-3.458-6.964-14.474-29.421-15.04-34.085-.4-3.3-3.878-25.135-11.471-37.947-1.811-3.075 1.119-15.309 1.119-15.309z"
            fill="#18206b"
          />
          <path
            data-name="Path 11390"
            d="M385.492 241.629a9.641 9.641 0 005.51 1.533c4.377.087 15.225-1.117 15.225-1.117a9.012 9.012 0 01.463 2.769s-13.249 3.341-20.93.487a4.873 4.873 0 01-.268-3.672z"
            fill="#233862"
          />
          <path
            data-name="Path 11391"
            d="M389.953 246.942a2.279 2.279 0 112-2.26 2.138 2.138 0 01-2 2.26zm0-3.86a1.643 1.643 0 100-.008z"
            fill="#fff"
          />
          <path
            data-name="Path 11392"
            d="M419.083 245.443l-10.757 9.369a1.87 1.87 0 01-2.635-.183l-13.728-15.765a1.867 1.867 0 01.183-2.635l10.757-9.369a1.87 1.87 0 012.634.183l13.728 15.765a1.868 1.868 0 01-.182 2.635z"
            fill="#2b478b"
          />
          <path
            data-name="Path 11393"
            d="M403.167 244.259c-.153.04-5.716.694-5.716 1.844a3.447 3.447 0 003.166 3.019c.624-.034 3.494-2.673 3.494-2.673z"
            fill="#ffb27d"
          />
          <path
            data-name="Path 11394"
            d="M400.312 211.118a18.417 18.417 0 01-.992-6.766l-.42.083-7.064 1.409s.159 2.214.165 4.317v.052c0 1.811-1.23 3.645 1.688 4.365.901.213 7.951-.24 6.623-3.46z"
            fill="#ffb27d"
          />
          <path
            data-name="Path 11395"
            d="M391.845 205.834s.159 2.214.165 4.317c3.952-.111 6.038-3.717 6.9-5.717z"
            fill="#e8945b"
          />
          <path
            data-name="Path 11396"
            d="M390.515 207.815s9.353.155 9.361-5.671 1.208-9.733-4.756-10.077-7.135 1.878-7.609 3.824.571 11.733 3.004 11.924z"
            fill="#ffb27d"
          />
          <path
            data-name="Path 11397"
            d="M390.861 191.925s2.56 6.843 6.49 7.849 5.635-.042 5.635-.042a11.134 11.134 0 01-3.641-6.577s-6.554-4.482-8.484-1.23z"
            fill="#163560"
          />
          <path
            data-name="Path 11398"
            d="M391.495 192.48a5.8 5.8 0 00-2.681 2.1 9.4 9.4 0 00-1.264 5.349s-1.93-4.647.238-7.275c2.301-2.792 3.707-.174 3.707-.174z"
            fill="#163560"
          />
          <path
            data-name="Path 11399"
            d="M403.168 244.259a6.326 6.326 0 00-2.214-.3c-.881.125-1.549-.018-1.549.232s1.149.366 1.395.487a11.928 11.928 0 002.368-.419z"
            fill="#ffb27d"
          />
          <path
            data-name="Path 11400"
            d="M404.83 211.722s6.642.467 9.185 6.654 7.374 16.576 7.374 18.314-2.7 7.134-17.185 10.232c0 0-1.5-1.576-1.409-2.818 0 0 9.044-7.768 9.018-8.676-.044-1.717-1.481-3.985-9.423-11.928-2.154-2.15 2.44-11.778 2.44-11.778z"
            fill="#ffa561"
          />
          <path
            data-name="Path 11401"
            d="M180.101 27.775s-5.327-.9-8.706 1.652-3.917 1.725-5.822 3.3.044 3.454-1.006 4.5-1.093 3.077.467 3.6.509 3.377 3.886 3.753 1.864 1.938 5.068 2.176 5.853.348 7.541 1.057a2.666 2.666 0 003.7-1.31c.481-1.286 1.833.372 2.228-1.385s-1.006-2.451-.225-3.878 2.737-11.548-7.131-13.465z"
            fill="#233862"
          />
          <path
            data-name="Path 11402"
            d="M189.315 130.026a1.315 1.315 0 00-.225 1.409 8.807 8.807 0 002.785 3.019c.167.135.316.256.447.366.034.03.068.06.1.091s.052.046.078.068c1.222 1.111.767 1.37 2.966 3.623 2.508 2.572 4.226 2.606 4.708 2.367.4-.2-.437-1.572-1.377-3.109l-.137-.223-.374-.618c-1.1-1.85-.827-2.723-.59-5.49.2-2.248 3.407-12.579 3.407-12.579l-4.776-.787s-1.379 8.215-2.952 9.491c-.841.68-1.787.694-2.6 1.208l-.169.109a6.283 6.283 0 00-1.291 1.055z"
            fill="#ffb27d"
          />
          <path
            data-name="Path 11403"
            d="M189.315 130.026a1.315 1.315 0 00-.225 1.409 10.135 10.135 0 002.789 3c.165.135.312.26.443.374.034.03.068.06.1.091a1.04 1.04 0 00.078.068c1.222 1.111.767 1.371 2.966 3.623 2.508 2.572 4.226 2.606 4.708 2.367.4-.2-.437-1.572-1.377-3.109a10.591 10.591 0 01-4.46-3.238c-1.511-1.9-2.53-4.351-3.56-5.768l-.169.109a6.287 6.287 0 00-1.293 1.074z"
            fill="#233862"
          />
          <path
            data-name="Path 11404"
            d="M227.755 126.78c.3 1.469 2.4 1.208 4.742.62s1.787.095 5.122-.3 4.337-1.644 4.428-2.141c.088-.441-1.562-.584-3.333-.775l-.67-.076c-2-.235-3.47-1.513-5.291-2.56-1.725-.99-4.317-5.056-4.317-5.056l-4.575.4s2.427 3.623 3.367 5.211a5.532 5.532 0 01.473 3.115 5.826 5.826 0 00.054 1.562z"
            fill="#ffb27d"
          />
          <path
            data-name="Path 11405"
            d="M232.497 127.396c2.341-.59 1.787.095 5.122-.3s4.337-1.644 4.428-2.141c.089-.441-1.562-.584-3.333-.775l-.016.034a9.392 9.392 0 01-4.768 1.517c-2.264.072-4.667-.559-6.239-.523a5.836 5.836 0 00.046 1.566c.322 1.471 2.42 1.212 4.76.622z"
            fill="#233862"
          />
          <path
            data-name="Path 11406"
            d="M210.011 97.636l-4.2 11.542-5.478 15.07a9.069 9.069 0 01-2.97-.25 12.827 12.827 0 01-2.878-1.377s1.437-16.157 4.265-25.435a16.491 16.491 0 012.451-5.4c4.449-5.334 8.81 5.85 8.81 5.85z"
            fill="#ed7d2b"
          />
          <path
            data-name="Path 11407"
            d="M205.531 79.385c-2.818-.884-10.793.334-18.813 1.962l-1.7-2.761-17.354-1.234s-5.434 12.023-2.443 20.8c.58 1.7 3.359 1.763 3.359 1.763s10.167.111 13.518.087c8.626-.06 18.214-6.058 19.458-6.315 2.037-.423 2.88 3.651 4.949 7.917s19.3 18.827 19.3 18.827a15.672 15.672 0 003.717-.4 3.666 3.666 0 001.59-1.02s-19.246-37.632-25.581-39.626z"
            fill="#f99746"
          />
          <path
            data-name="Path 11408"
            d="M179.549 51.84c.028.018-3.031 1.087-5.088.2-1.934-.839-3.421-4-3.389-4 .878-.048 1.833-.821 2.54-5.861l.376.133 6.3 2.214s-.441 2.013-.722 3.939c-.247 1.606-.361 3.15-.017 3.375z"
            fill="#ffb27d"
          />
          <path
            data-name="Path 11409"
            d="M180.285 44.519s-.27 1.409-.642 3.435c-3.623-.624-5.134-3.705-5.655-5.651z"
            fill="#ed975d"
          />
          <path
            data-name="Path 11410"
            d="M181.235 46.511s-8.6-1.093-7.849-6.44.167-9.089 5.692-8.618 6.3 2.665 6.478 4.51-2.065 10.695-4.321 10.548z"
            fill="#ffb27d"
          />
          <path
            data-name="Path 11411"
            d="M185.231 33.041s-5.468 4.78-9.208 5.2-5.156-.793-5.156-.793a14.611 14.611 0 003.5-4.812 2.632 2.632 0 012.16-1.566c2.66-.249 7.723-.391 8.704 1.971z"
            fill="#233862"
          />
          <path
            data-name="Path 11412"
            d="M181.789 32.641a13.549 13.549 0 012.441 3.081 10.374 10.374 0 01.32 5.528s2.83-5.6 1.188-8.294c-1.743-2.858-3.949-.315-3.949-.315z"
            fill="#233862"
          />
          <path
            data-name="Path 11413"
            d="M186.871 64.451c-.137 17.4.026 13.762-1.866 15.426a7.286 7.286 0 01-3.437.771c-5.333.392-14.716-.421-15.08-1.409-1.254-3.4-.4-4.468-1.457-9.684a62.306 62.306 0 00-.4-1.811c-.88-3.58-1.723-4.8 1.274-10.58 2.717-5.233 5.549-9.5 5.806-9.344 7.3 4.261 7.849.632 7.849.632s7.383 7.512 7.311 15.999z"
            fill="#8c9df4"
          />
          <path
            data-name="Path 11414"
            d="M205.813 109.179l-5.478 15.07a9.065 9.065 0 01-2.97-.25 12.832 12.832 0 01-2.878-1.377s1.437-16.157 4.265-25.435z"
            fill="#f99746"
          />
          <path
            data-name="Path 11415"
            d="M179.563 48.457s7.485 1.208 8.386 4.428 6.2 22.1 6.2 22.1-3.8.71-5.565-1.034-6.225-16.245-6.225-16.245z"
            fill="#8c9df4"
          />
          <path
            data-name="Path 11416"
            d="M181.571 80.649c-5.333.392-14.716-.421-15.08-1.409-1.254-3.4-.4-4.468-1.457-9.684l2.522-7.263s-.368 8.072 2.027 10.177 9.771 4.025 10.94 5.792a6.516 6.516 0 011.048 2.387z"
            fill="#6980e2"
          />
          <path
            data-name="Path 11417"
            d="M175.435 77.297s5.255-1.208 6.106-.747a12.311 12.311 0 013.212 2.745c.272.6-1.894-.437-2.594-.62a6.307 6.307 0 00-2.232.505 7.41 7.41 0 01-4 .431z"
            fill="#ffb27d"
          />
          <path
            data-name="Path 11418"
            d="M171.702 47.824s-7.064.479-9.489 3.914c-3.411 4.83-10.1 25.344-6.162 28.047 4.428 3.043 20.071.662 20.071.662s.505-2.439-.23-3.623-12.528-2.993-13.081-3.532 6.722-10.65 6.712-12.277 2.179-13.191 2.179-13.191z"
            fill="#8c9df4"
          />
          <path
            data-name="Path 11419"
            d="M181.807 78.014a10.468 10.468 0 001.475 1.582 1.076 1.076 0 00.6.123l-.749-1.335z"
            fill="#ffb27d"
          />
          <path
            data-name="Path 11420"
            d="M181.533 76.551l3.22 1.538a.574.574 0 01-.529.2 7.561 7.561 0 01-1.395-.372z"
            fill="#ffb27d"
          />
          <path
            data-name="Path 11421"
            d="M182.596 81.89l25.362-.179 7.495-19.025-25.322.179z"
            fill="#233862"
          />
          <path
            data-name="Path 11422"
            d="M208.25 80.97l-33.489.237v.739l33.193-.235z"
            fill="#233862"
          />
          <path
            data-name="Path 11423"
            d="M201.487 72.272a.884.884 0 00-.87-1.208 1.726 1.726 0 00-1.544 1.218.884.884 0 00.87 1.208 1.727 1.727 0 001.544-1.218z"
            fill="#ebf3fa"
          />
          <path
            data-name="Path 11424"
            d="M53.598 345.278h18.516c.99-.841-.686-2.753-2.441-2.88a10.665 10.665 0 00-2.818.334c-.256-3.383-1.709-18.59-7.191-17.978-6.162.685 0 6.7 1.743 10.264a84.688 84.688 0 013.274 8.2c-.5.107-1.018.213-1.548.312-.817-2.51-3.856-10.946-7.722-10.465-4.538.576-2.715 3.958.5 5.967 2.359 1.477 5.257 3.574 6.641 4.589a19.443 19.443 0 01-3.623.29c-3.181-.07-4.731.863-5.331 1.367z"
            fill="#a8d29f"
          />
          <path
            data-name="Path 11425"
            d="M454.155 345.236h-20.477c-1.1-.932.761-3.045 2.7-3.188a11.965 11.965 0 013.124.37c.282-3.743 1.892-20.566 7.956-19.89 6.819.757 0 7.408-1.928 11.347a94.04 94.04 0 00-3.623 9.075c.555.121 1.127.238 1.713.346.9-2.775 4.266-12.109 8.543-11.566 5.021.636 3 4.379-.556 6.6-2.616 1.634-5.818 3.955-7.339 5.078a21.846 21.846 0 004 .32c3.511-.083 5.223.949 5.887 1.508z"
            fill="#a8d29f"
          />
          <path
            data-name="Path 11426"
            d="M22.555 345.207H483.43a.584.584 0 01.584.583v.358a.584.584 0 01-.584.584H22.555a.586.586 0 01-.586-.586v-.358a.583.583 0 01.586-.581z"
            fill="#233862"
          />
        </g>
      </g>
    </svg>
  )
}

const MemoSvgComponent = React.memo(SvgComponent)
export default MemoSvgComponent
